/*********************************************************************
* © Copyright IBM Corp. 2024
*********************************************************************/
import React from 'react'
import {
  MessageDetails,
  MessageRow,
  MessageRowProps,
  MessageDetailsTableView,
  MessageDetailsJsonView
} from './Message'
import {EventDependentComponent} from '../ConfigurationAuditList/areaContracts'
import {areaDependentComponents} from '../ConfigurationAuditList/areas'

const DefaultConfigurationChangeDetailsTableView: EventDependentComponent = ({item}) => (
  <MessageDetailsTableView properties={item.payload || {}} />
)

export const ConfigurationChangeMessage: React.FC<MessageRowProps> = ({item, showDetails}) => {
  // nosemgrep: eslint.detect-object-injection
  const areaDependentSettings = areaDependentComponents[item.area!]
  const TableViewComponent =
    areaDependentSettings?.TableViewComponent ?? DefaultConfigurationChangeDetailsTableView

  return (
    <MessageRow
      item={item}
      showDetails={showDetails}
      messageDetailsView={
        <MessageDetails
          showDetails
          tableView={<TableViewComponent item={item} />}
          jsonView={<MessageDetailsJsonView properties={item || {}} />}
        />
      }
    />
  )
}
